/* eslint-disable react/jsx-no-target-blank */
/* eslint-disable @typescript-eslint/no-unused-vars */
/* eslint-disable jsx-a11y/anchor-is-valid */
import { useIntl } from 'react-intl'
import { KTIcon } from '../../../helpers'
import { AsideMenuItemWithSub } from './AsideMenuItemWithSub'
import { AsideMenuItem } from './AsideMenuItem'
import { useSelector } from 'react-redux'

export function AsideMenuMain() {
  const intl = useIntl()

  return (
    <>

      <AsideMenuItem to='/dashboard' title='Orders Dashboard' hasBullet={false} />


      <AsideMenuItem to='/invoice' title='Invoice Upload' hasBullet={false} />


      {/* <AsideMenuItem to='/notifications' title='Notifications' hasBullet={false} /> */}

    </>
  )
}
